// extracted by mini-css-extract-plugin
export default {"table_info":"tournament_table_head_table_info__x1zjb","th_lattice":"tournament_table_head_th_lattice__KTtIQ","th_place":"tournament_table_head_th_place__88ug1"};